import { Titration } from "src/api/types";
import WhiteCard from "../WhiteCard";
import { LinearProgress, Stack, Typography } from "@mui/material";
import DataTable from "../DataTable";
import { useColumns } from "src/pages/PriceDetails/components/Titrations/useColumns";

interface Props {
  titrations: Titration[];
  variant: "Monthly" | "Quarterly";
  loading: boolean;
}

const TitrationsTable = ({ titrations, variant, loading }: Props) => {
  const columns = useColumns();

  return (
    <WhiteCard width={"100%"} gap={3}>
      <Stack gap={1}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography fontWeight={600}>{variant} Titrations</Typography>
        </Stack>
      </Stack>
      {loading ? (
        <LinearProgress />
      ) : (
        <DataTable columns={columns} data={titrations} primaryKey="id" />
      )}
      <Stack />
    </WhiteCard>
  );
};

export default TitrationsTable;
